/**
 * External dependencies
 */

import { get, values } from 'lodash';


export const getAllBarcodeLookupPlans = (state) => values(get(state, ['barcodeLookupPlans', 'items']));

export const requestingBarcodeLookupPlans = (state) => get(state, ['barcodeLookupPlans', 'requesting']);

export const errorRequestingBarcodeLookupPlans = (state) => get(state, ['barcodeLookupPlans', 'error']);